import React from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardHeader,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslations, useUser } from "hooks";
import { getTranslation } from "common";

export default function Welcome() {
  const translations = useTranslations();
  const user = useUser();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/login");
  };
  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <Container
        maxWidth="sm"
        sx={{
          justifyContent: "center",
          flexDirection: "column",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Card>
          <CardHeader
            title={getTranslation(
              translations,
              "register.label.welcome"
            ).replace("%1", user?.email || "")}
          />
          <CardActions>
            <Button
              size="small"
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleClick}
            >
              {getTranslation(translations, "register.label.welcome_button")}
            </Button>
          </CardActions>
        </Card>
      </Container>
    </Box>
  );
}
